import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { plainToClassFromExist } from "class-transformer";
import { DeviceTokenApiModel } from "../models/device-token.api-model";

export interface DeviceTokenUpsertPayload {
  token: string;
  platform: 'ios' | 'android';
  locale: string;
  appVersion?: string;
  deviceId?: string;
}

@Injectable()
export class DeviceTokenRestService {
  private readonly resource: string = '/device_tokens';

  constructor(private http: HttpClient) {
  }

  public upsert(payload: DeviceTokenUpsertPayload): Observable<DeviceTokenApiModel> {
    return this.http.post<DeviceTokenApiModel>(environment.apiUrl + this.resource, payload)
      .pipe(map(result => plainToClassFromExist(new DeviceTokenApiModel(), result as object)));
  }

  public disable(id: string): Observable<void> {
    return this.http.delete<void>(environment.apiUrl + this.resource + '/' + id);
  }
}
